import React from 'react';
import { FaqItem } from '../FaqItem';
import { SectionHeading } from './SectionHeading';
import { faqs } from '../../data/content';
export function FaqSection() {
  return <section aria-labelledby="faq-heading" className="bg-brand-paper px-5 py-16 lg:px-8 lg:py-24" data-id="element-83" data-mp="2kxfiqho1rgor">
      <div className="mx-auto max-w-3xl" data-id="element-84" data-mp="2fyccitwbz4f7">
        <SectionHeading id="faq-heading" title="Questions fréquentes" data-id="element-85" data-mp="2fxaz4irue5ub" />
        <div className="mt-10 border-t border-brand-charcoal/12" data-id="element-86" data-mp="2txlt3uog80jp">
          {faqs.map(faq => <FaqItem key={faq.question} {...faq} data-id="element-87" data-mp="2pws7x92e4zui" />)}
        </div>
      </div>
    </section>;
}